import { FC, forwardRef, PropsWithChildren } from 'react'
import { Text } from '../platform/Text'
import { TextProps } from '../typings/TextProps'
import { FontWeight } from '../../font/typings/FontWeight'
import { Color } from '../../colors/Color'

export const SectionHeader: FC<PropsWithChildren<TextProps>> = forwardRef(
  (
    {
      color = Color.Gray.Shade1,
      fontSize = 14,
      fontWeight = FontWeight.Bold,
      lineHeight = 19,
      textTransform = 'uppercase',
      ...props
    },
    ref
  ) => (
    <Text
      ref={ref}
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      textTransform={textTransform}
      {...props}
    />
  )
)
